import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Instagram } from "lucide-react";
import { INSTAGRAM_URL } from "../lib/constants";

const navItems = [
  { to: "/", label: "Início" },
  { to: "/sobre", label: "Sobre" },
  { to: "/noticias", label: "Notícias" },
  { to: "/eco-loja", label: "Eco Loja" },
  { to: "/vagas", label: "Vagas" },
  { to: "/setor-social", label: "Setor Social" },
  { to: "/canal-reclamacoes", label: "Canal" },
  { to: "/instagram", label: "Instagram" },
  { to: "/contato", label: "Contato" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const isHome = loc.pathname === "/";

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        isHome
          ? "bg-white/70 backdrop-blur-xl border-b border-forest-700/10"
          : "bg-cream-100/85 backdrop-blur-xl border-b border-forest-700/10"
      }`}
    >
      <div className="container-page flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-home-logo" className="flex items-center gap-3 group">
          <div className="relative w-11 h-11 rounded-full bg-forest-700 flex items-center justify-center overflow-hidden transition-transform duration-500 group-hover:rotate-6">
            <span className="font-display text-cream-100 text-xl">C</span>
          </div>
          <div className="leading-tight">
            <div className="font-display text-lg text-forest-900 tracking-tight">COOMFLONA</div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-forest-700/70">Flona do Tapajós</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {navItems.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.to === "/"}
              data-testid={`nav-${it.label.toLowerCase().replace(/\s/g, "-")}-link`}
              className={({ isActive }) =>
                `relative text-sm font-medium transition-colors ${
                  isActive ? "text-forest-900" : "text-forest-700/80 hover:text-forest-900"
                } after:absolute after:left-0 after:-bottom-1 after:h-px after:bg-copaiba-500 after:transition-all after:duration-300 ${
                  isActive ? "after:w-full" : "after:w-0 hover:after:w-full"
                }`
              }
            >
              {it.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram COOMFLONA"
            data-testid="header-instagram-link"
            className="p-2 text-forest-700 hover:text-copaiba-500 transition-colors"
          >
            <Instagram className="w-5 h-5" />
          </a>
          <Link to="/eco-loja" data-testid="header-cta-shop" className="btn-primary !py-2.5 !px-5">
            Visitar a Loja
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 text-forest-900"
          aria-label="Abrir menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-forest-700/10 bg-cream-100">
          <div className="container-page py-6 flex flex-col gap-1">
            {navItems.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${it.label.toLowerCase()}-link`}
                className={({ isActive }) =>
                  `py-3 px-2 text-base font-medium border-b border-forest-700/10 ${
                    isActive ? "text-forest-900" : "text-forest-700/80"
                  }`
                }
              >
                {it.label}
              </NavLink>
            ))}
            <Link
              to="/eco-loja"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-shop"
              className="btn-primary mt-4"
            >
              Visitar a Loja
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
